/**
 * @param {number} [n] - The original number to convert.
 * @param {number} [fixTo = 2] - The limited decimal numbers. The default is 2.
 */
export const formatDecimals = (n: number, fixTo = 2) => {
    const hasDecimals = n % 1 != 0;

    return hasDecimals ? Number(n.toFixed(fixTo)) : n;
};
